




























import Vue from 'vue';
import { mapState } from 'vuex';
import { buildOAuthUrl, getValidReferrer } from './utils';
import SignUpHeader from './SignUpHeader/SignUpHeader.vue';
import SignUpSocialButtons from './SignUpSocialButtons/SignUpSocialButtons.vue';
import SignUpForm from './SignUpForm/SignUpForm.vue';
import SignUpFooter from './SignUpFooter/SignUpFooter.vue';
import type { UserFormFields } from './SignUpForm/types';
import { isUserInsideExternalApp } from '~/utils/externalRedirections';
import { skipOnboardingIfPageInException } from '~/components/partials/war-room/WarRoomSignUp/skipOnboarding';
import Modal from '~/components/common/Modal/Modal.vue';
import CloseIcon from '~/assets/svg/close.vue.svg';

export default Vue.extend({
  name: 'SignUpModal',
  components: {
    Modal,
    SignUpHeader,
    SignUpSocialButtons,
    SignUpForm,
    SignUpFooter,
    CloseIcon,
  },
  data() {
    return {
      isUserInsideExternalApp: false,
      isLoading: false,
    };
  },
  computed: {
    ...mapState(['promo']),
    referer(): string {
      const { query } = this.$route;
      return (query?.refferer || query?.referer) as string;
    },
  },
  mounted() {
    this.isUserInsideExternalApp = isUserInsideExternalApp(
      document.referrer,
      navigator.userAgent,
      this.$device.isWebView,
    );
  },
  methods: {
    /**
     * Sign up by form with user/password for WebView (linkedin)
     */
    async handleSignUp(user: UserFormFields) {
      const { query } = this.$route;
      this.isLoading = true;

      try {
        await this.$axios.$post('/users.json', {
          user: {
            ...user,
            password_confirmation: user.password,
            promo: this.promo,
            redirect_path: this.$pages.WAR_ROOM_POSTS_TAB_MYFEED_PAGE.path,
          },
        });

        await this.$auth.fetchUser();

        await this.$store.dispatch('portfolio/load', { slug: this.$auth.user.slug });
        this.$analytics.logSignUp('email', this.$auth.user.amplitudeUser);
        if (query?.event) {
          this.$analytics.logEvent(query.event as string);
        }

        // Do we still use `referer` cookie?
        const referer = this.referer || this.$cookies.get('referer');
        if (getValidReferrer(referer)) {
          this.$cookies.remove('referer');
          await this.$3rdParty.loadImmediately(['facebook', 'tiktok', 'linkedin']);
          window.location.href = referer;
        } else {
          // We use window.location.href instead of $router because of the bug in WebView:
          // Page could redirect the user, but user state wasn't updated somehow
          // and app shows SignUp modal again
          window.location.href = '/onboarding-v3/';
        }
      } catch (error) {
        // We don't remove isLoading in success state because of issue in WebView:
        // On mobile phone because next page could load too long - user could click button again
        this.isLoading = false;
        this.$sentryUtils.error(error as Error, 'webview_signup');
      }
    },

    loginWith(provider: () => void) {
      skipOnboardingIfPageInException(this.$route.path);
      provider();
    },

    loginWithLinkedin() {
      this.$analytics.logEvent('global__war-room-sign-up-modal__linkedin-button__click');
      const extraParams = this.promo ? { promo: this.promo } : {};
      window.location.assign(buildOAuthUrl('linkedin', 'signUp', this.$route, extraParams));
    },

    loginWithGoogle() {
      this.$analytics.logEvent('global__war-room-sign-up-modal__google-button__click');
      const extraParams = this.promo ? { promo: this.promo } : {};
      window.location.assign(buildOAuthUrl('google', 'signUp', this.$route, extraParams));
    },

    navigateToSignIn() {
      this.$analytics.logEvent('global__war-room-sign-up-modal__login-link__click');
      this.$modal.showWithRoute('SIGN_IN_MODAL');
    },
  },
});
